/** Safari reads @page declarations but does not apply named pages consistently.
 * Reuse the rule from App.css as an unnamed rule while this document is open.
 * Removing it restores normal printing for all other views.
 */
export function installPrintPage(name: string): () => void {
  for (const sheet of Array.from(document.styleSheets)) {
    let rules: CSSRuleList;
    try { rules = sheet.cssRules; } catch { continue; } // Cross-origin stylesheets are not readable.
    const page = Array.from(rules).find(rule => rule.cssText.startsWith(`@page ${name} {`));
    if (!page) continue;
    const style = document.createElement('style');
    // @page is already print-only. Safari needs it available before print
    // media is activated, so do not put media="print" on this stylesheet.
    style.dataset.printPage = name;
    style.textContent = page.cssText.replace(`@page ${name}`, '@page');
    document.head.appendChild(style);
    return () => { style.remove(); };
  }
  return () => {};
}
